export default __webpack_public_path__ + "static/media/thunderkick.c495831f.png";